var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui-map" }, [
    _c("div", { ref: "map", staticClass: "gm" }),
    _vm._v(" "),
    _c("div", { ref: "overlay" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }